import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import Feed from './components/Feed/Feed';
import Post from './components/Post/Post';
import Profile from './components/Profile/Profile';
import Chat from './components/Chat/Chat';

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={Login} />
        <Route path="/signup" component={Signup} />
        <Route path="/feed" component={Feed} />
        <Route path="/post" component={Post} />
        <Route path="/profile/:id" component={Profile} />
        <Route path="/chat/:id" component={Chat} />
      </Switch>
    </Router>
  );
};

export default App;
